import React, { useEffect, useState } from 'react';
import "./ChemoApprovalRequest.scss";
import { useHistory, useLocation } from 'react-router';
import { useSelector } from "react-redux";
import Button from "components/Button";
import { updateChemoOrderPendingRequest, getChemoApprovalsList } from 'core/services/api/mrdService';
import Toast from "components/Toast";
import PDFViewer from 'components/PdfViewer/PdfViewer';
import { MocUserRole } from 'core/services/models/Enums';
import fileUtils from 'fileUtils';

function ChemoApprovalRequest() {
    const history = useHistory();
    const location = useLocation();

    const userDetail = useSelector((state: any) => state?.user?.userDetail)
    const userRole = useSelector((state: any) => state?.user?.role)
    const [data, setData] = useState<any>();
    const [comment, setComment] = useState<any>()
    const [displayToast, toggleDisplayToast] = useState<any>();

    useEffect(() => {
        if (location?.state?.id) {
            let url = `chemo-order/pending-approvals/${location?.state?.id}`
            getChemoApprovalsList(url)
                .then((res: any) => {
                    setData(res)
                    setComment(res?.comment ? res?.comment : "")
                })
                .catch((err: any) => {
                    console.log(err?.message)
                })
        }
    }, [location?.state])

    const approvalRequest = (() => {
        //Commenting the validation check for comment field
        // if (comment?.length > 0) {
        const updatedData: any = {}
        updatedData["status"] = "APPROVED"
        updatedData["comment"] = comment
        updateChemoOrderPendingRequest(data?.id, updatedData).then((res: any) => {
            setData(res)
            toggleDisplayToast({ text: "Request has been approved successfully", type: "success" })
        }).catch((err: any) => {
            toggleDisplayToast({ text: "Request was not able to proceed", type: "error" })
        })
        // }
        // else {
        //     toggleDisplayToast({ text: "Please enter comment to proceed", type: "error" })
        // }
    })

    const cancelRequest = (() => {
        //Commenting the validation check for comment field
        // if (comment?.length > 0) {
        const updatedData: any = {}
        updatedData["status"] = "REJECTED"
        updatedData["comment"] = comment
        updateChemoOrderPendingRequest(data?.id, updatedData).then((res: any) => {
            setData(res)
            toggleDisplayToast({ text: "Request has been rejected successfully", type: "success" })
        }).catch((err: any) => {
            toggleDisplayToast({ text: "Request was not able to proceed", type: "error" })
        })
        // } 
        // else {
        //     toggleDisplayToast({ text: "Please enter comment to proceed", type: "error" })
        // }
    })

    return (
        <div className='chemo-approval-wrapper'>
            <section className='section-wrapper'>
                <div className='top-heading-wrapper'>
                    <div className='chemo-approval-heading-container'>
                        <div
                            className="approval-back-image"
                            onClick={() => {
                                // history.goBack()
                                history.push({
                                    pathname: "/viewAllRequest",
                                    state: {
                                        tabValue: userDetail?.currentRole === MocUserRole.CONSULTANT ? 2 : 1,
                                    },
                                })
                            }}
                        >
                            <img
                                src={"../../../../assets/images/back-icon.svg"}
                                alt="back button"
                                className="image-top-wrapper"
                            />
                        </div>
                        <div className='Heading-Chemo-Approval'>Pending Chemo Approval Requests</div>
                    </div>


                </div>
            </section>
            <div className="download-chemo-pdf">
                <a
                    className='download-chemo-pdf-btn'
                    // href={data?.pdfUrl}
                    // download={data?.pdfUrl}
                    onClick={() => fileUtils.downloadFileViaUrl(data?.pdfUrl, `ChemoApproval ${data?.patientMocId ? data?.patientMocId : ""} ${data?.patientName ? data?.patientName : ""}.pdf`)}
                >
                    Download PDF
                </a>
            </div>
            <PDFViewer url={data?.pdfUrl} />
            <div className="comment-heading">Comment</div>
            <div className="textarea">
                <textarea
                    name=""
                    id=""
                    value={comment}
                    onChange={(e) =>
                        setComment(e.target.value)
                    }
                    disabled={data?.status === "APPROVED" || data?.status === "REJECTED" ? true : false}
                    className={(data?.status === "APPROVED" || data?.status === "REJECTED" ? true : false) ? "disabled" : ""}
                />
            </div>
            {
                userRole === MocUserRole.CONSULTANT ? (
                    <section className='button-section' style={{ marginBottom: '50px' }}>
                        <Button
                            text="Approve"
                            type="submit"
                            id="mrd-approve"
                            onClick={approvalRequest}
                            disabled={data?.status === "APPROVED" || data?.status === "REJECTED" ? true : false}
                        />

                        <Button
                            text="Reject"
                            type="submit"
                            outline={true}
                            id="mrd-approve-submit"
                            onClick={cancelRequest}
                            disabled={data?.status === "APPROVED" || data?.status === "REJECTED" ? true : false}
                        />
                    </section>
                ) : (
                    ""
                )
            }
            {displayToast && (
                <Toast
                    textMessage={displayToast?.text}
                    type={displayToast?.type}
                    onClose={() => {
                        toggleDisplayToast(false)
                        if (!(displayToast?.type === "error")) {
                            // history.push("/viewAllRequest");
                            history.push({
                                pathname: "/viewAllRequest",
                                state: {
                                    tabValue: userDetail?.currentRole === MocUserRole.CONSULTANT ? 2 : 1,
                                },
                            })
                        }
                        // if (displayToast?.type === "success") {
                        //   window.location.reload();
                        // }
                    }}
                    onCloseText="Close"
                    onClickText={null}
                />
            )}
        </div >

    )
}

export default ChemoApprovalRequest